/**
 * API URL prefix for the admin notification centre.
 * Note: axios.defaults.baseURL already includes the "/api" segment,
 * so we only prepend the admin scope here.
 */
export const NOTIFICATIONS_API_PREFIX = "/admin/notifications";

/**
 * Endpoint paths exposed by the admin notification centre.
 */
export const NOTIFICATIONS_ENDPOINTS = {
    list: `${NOTIFICATIONS_API_PREFIX}/`,
    read: (notificationId) => `${NOTIFICATIONS_API_PREFIX}/read/${notificationId}`,
    readAll: `${NOTIFICATIONS_API_PREFIX}/read_all`,
};

/**
 * Presentation of each incident type: the title shown in the list, the screen
 * to jump to, and the severity colour. Unknown types stay readable rather than
 * breaking the list, so a new backend incident degrades gracefully.
 */
export const INCIDENT_META = {
    treasury_under_covered: {
        title: "Canal de trésorerie à découvert",
        description:
            "Un canal ne peut plus honorer les retraits de ses artistes. Un transfert depuis l'autre canal est nécessaire.",
        link: "/admin/treasury",
        linkLabel: "Voir la trésorerie",
        colorScheme: "red",
    },
    dispatch_config_failed: {
        title: "Échec de configuration de répartition",
        description: "La répartition des gains d'un groupe n'a pas pu être appliquée.",
        link: "/admin/transactions",
        linkLabel: "Voir les transactions",
        colorScheme: "orange",
    },
};

/**
 * Fallback presentation for an incident type the front does not know yet.
 */
export const DEFAULT_INCIDENT_META = {
    title: "Incident",
    description: "Un incident a été signalé par l'API.",
    link: null,
    linkLabel: null,
    colorScheme: "gray",
};

/**
 * Socket event emitted by notify_admins on the admin's own room.
 */
export const ADMIN_NOTIFICATION_EVENT = "admin_notification";
